export const roundedStyleSelect = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? '#fff' : '#fff',
        border: state.isFocused ? '1px solid #8e9fd5' : '1px solid #e2e8f0',
        borderColor: state.isFocused ? '#8e9fd5' : '#e2e8f0',
        boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(28, 63, 170, .25)' : '0 1px 2px 0 rgba(0, 0, 0, .05)',
        color: state.isFocused ? '#2d3748' : '#2d3748',
        borderRadius: '30px',
        '&:hover': { borderColor: '#e2e8f0' },
    })
};

export const styleSelect = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? '#fff' : '#fff',
        border: state.isFocused ? '1px solid #8e9fd5' : '1px solid #e2e8f0',
        borderColor: state.isFocused ? '#8e9fd5' : '#e2e8f0',
        boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(28, 63, 170, .25)' : '0 1px 2px 0 rgba(0, 0, 0, .05)',
        color: state.isFocused ? '#2d3748' : '#2d3748',
        '&:hover': { borderColor: '#e2e8f0' },
    })
};

export const investigationStyleSelect = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? '#fff' : '#fff',
        height: '45px',
        border: state.isFocused ? '1px solid #8e9fd5' : '1px solid #e2e8f0',
        borderColor: state.isFocused ? '#8e9fd5' : '#e2e8f0',
        boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(28, 63, 170, .25)' : '0 1px 2px 0 rgba(0, 0, 0, .05)',
        color: state.isFocused ? '#2d3748' : '#2d3748',
        '&:hover': { borderColor: '#e2e8f0' },
    })
};

export const printStyles = {
    control: (provided, state) => ({
        ...provided,
        '@media print': {
            backgroundImage: 'url("/images/logo.png")',
            backgroundRepeat: 'repeat-y',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
        },
    }),
};

